type HeaderProviderFn = () => Record<string, string> | Promise<Record<string, string>>;
export type TypeCredentialsMode = 'omit' | 'same-origin' | 'include';
type OnUnauthorizedFn = () => Promise<Record<string, string> | null>;
type OnErrorFn = (error: Error) => void;

export interface IClientConfig {
  baseUrl: string;
  defaultHeaders?: Record<string, string>;
  headerProvider?: HeaderProviderFn;
  onUnauthorized?: OnUnauthorizedFn;
  onError?: OnErrorFn;
  timeout?: number;
  credentials?: TypeCredentialsMode;
}

export function createClientConfig({
  baseUrl,
  defaultHeaders = {
    'Content-Type': 'application/json',
  },
  headerProvider,
  onUnauthorized,
  onError,
  timeout = 30000,
  credentials = 'include',
}: {
  baseUrl: string;
  defaultHeaders?: Record<string, string>;
  headerProvider?: HeaderProviderFn;
  onUnauthorized?: OnUnauthorizedFn;
  onError?: OnErrorFn;
  timeout?: number;
  credentials?: TypeCredentialsMode;
}): IClientConfig {
  return {
    baseUrl,
    defaultHeaders,
    headerProvider,
    onUnauthorized,
    onError,
    timeout,
    credentials,
  };
}
